import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { finalize } from "rxjs";
import { GlobalLoadingService } from "@core/services/common/global-loading.service";

export const globalLoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(GlobalLoadingService);
  loadingService.registrarRequest();

  return next(req).pipe(finalize(() => loadingService.desregistrarRequest()));
};
